const initialState = {
  account: {
    connected: false,
    email: '',
    granted: false,
    isLoading: true,
  },
  oauthPath: '',
}

// Set the account as disconnected only so the connected account page
// will re-render and redirect to the disconnected account page where
// the account data will be fetched
const setAccountDeleted = (state) => ({
  ...state,
  account: {
    ...state.account,
    connected: false,
  },
})

const setAccountLoaded = (state, {
  connected,
  email,
  granted,
  oauth_path: oauthPath,
}) => ({
  ...state,
  account: {
    ...state.account,
    connected,
    email,
    granted,
  },
  oauthPath,
})

const setAccountLoading = (state, isLoading) => ({
  ...state,
  account: {
    ...state.account,
    isLoading,
  },
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GMAIL_DELETE_ACCOUNT_SUCCESS':
      return setAccountDeleted(state)
    case 'GMAIL_FETCH_ACCOUNT':
      return setAccountLoading(state, true)
    case 'GMAIL_FETCH_ACCOUNT_SUCCESS':
      return setAccountLoaded(state, payload)
    case 'GMAIL_FETCH_ACCOUNT_COMPLETE':
      return setAccountLoading(state, false)
    default:
      return state
  }
}
